angular
  .module("digitalLeasing.module")
  .component("dichiarazioneIdentificazioneFirmatari", {
    templateUrl: "ng/components/digitalLeasing/contractSignature/dichiarazioneIdentificazioneFirmatari/dichiarazioneIdentificazioneFirmatari.view.html",
    bindings: {
      model: "=",
      close: "&",
      sendArc: "&",
      financialModel: "<",
      sendFromDigital: "&",
    },
    controllerAs: "dicIdenFirCtrl",
    controller: DichiarazioneIdentificazioneFirmatariController,
  });

function DichiarazioneIdentificazioneFirmatariController(
  FileUploader,
  $configService,
  $rootScope,
  $financialApiService,
  $simulationService,
  $timeout,
  $scope,
  $transactionFactory,
  $modalService,
  $download
) {
  var self = this;
  self.tomorrow = moment().add(1, "days").format("DD/MM/YYYY");
  self.validationObj = {
    documentDate: {
      disabledDays: [0],
      disabledDates: [
        "01-01",
        "06-01",
        "25-04",
        "01-05",
        "02-06",
        "15-08",
        "01-11",
        "08-12",
        "25-12",
        "26-12",
      ],
    },
  };

  self.$onInit = function () {
    var tempModel = $transactionFactory.get();
    if (tempModel) {
      self.model = tempModel;
      self.enableSendDigital = tempModel.fromDigitalModule;
      $transactionFactory.clear();
    }
    self.model.confirmed = false;
    self.supportModel = {
      confirmed: null,
    };

    if (self.model.idDocAllegatoKey) {
      self.checkFileDownload = true;
    }

    self.choseIdentifierOrClient();
  };

  self.choseIdentifierOrClient = function () {
    if (self.model.identifiedByCm) {
      self.model.identificatore = self.model.clientManagerList && self.model.clientManagerList
        .find(function (
          element
        ) {
          return element.selected == true;
        });
    } else {
      self.model.identificatore = self.model.listaIdentificatori && self.model.listaIdentificatori
        .find(function (
          element
        ) {
          return element.selected == true;
        });
    }
  };

  self.generateDownloadLink = function (url) {
    return (
      $configService.getUrl() +
      "/uni/downloadGeneric/service-infos" +
      url +
      "/?token=" +
      $configService.getAppConfig().token
    );
  };

  self.fileDownload = function (downloadType, value) {
    if (downloadType == "garanti") {
      self.checkFileDownloadGar = true;
    } else if (downloadType == "priPf") {
      self.checkFileDownloadPriPf = true;
    } else if (downloadType == "privacyG") {
      self.checkFileDownloadPrivacyG = true;
    } else {
      self.checkFileDownload = true;
    }
    var input = {
      downloadKey: value
    }
    var url = "/uni/downloadGenericDigital/service-infos/"
    $download.getGenericDownload(url, input)
      .then(function (response) {
        console.log(response)
      })
  };

  // inizio procedura upload file
  self.uploader = new FileUploader({
    url: "",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
      "App-Name": $rootScope.portalName,
    },
  });

  self.uploadDataFunc = function (item, index) {
    var document =
      arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    self.checkGaranti =
      arguments.length > 3 && arguments[4] !== undefined ? arguments[4] : false;
    if (item) {
      self.uploadData = item;
    }
    self.uploadDocumenti = document;
  };

  self.finalUpload = function () {
    var formData = new FormData();
    if (self.checkGaranti == "garanti") {
      var filesUpload = document.querySelector("#uploadInput_document_gar").files;
    } else if (self.checkGaranti == "priGaranti") {
      var filesUpload = document.querySelector("#uploadInput_document_pri_gar").files;
    } else {
      var filesUpload = document.querySelector("#uploadInput_document").files;
    }

    filesUpload = Object.keys(filesUpload).map(function (key) {
      return filesUpload[key];
    });
    filesUpload.forEach(function (file) {
      appendToForm(formData, "file", file);
      appendToForm(formData, "type", "FINANCIAL");
      appendToForm(formData, "ndgCliente", self.financialModel.financialCustomer.metadata.riUserG.ndg);
      appendToForm(formData, "filename", file.name);
      appendToForm(formData, "idPratica", self.financialModel.leasingData.id);
      appendToForm(formData, "numeroAnno", self.financialModel.leasingData.preventivo.anno);
      appendToForm(formData, "numeroContratto", self.financialModel.leasingData.contratto.numero);
      appendToForm(formData, "modulo", self.financialModel.leasingData.contratto.modulo);
      appendToForm(formData, "numeroPreventivo", self.financialModel.leasingData.preventivo.numero);
      appendToForm(formData, "idDocNsil", self.model.idNsilAllegato);
      appendToForm(formData, "cdDoc", self.uploadDocumenti);


      $financialApiService
        .uploadDocOnDigital(formData)
        .then(function (response) {
          if (response.success) {
            if (self.checkGaranti == "garanti") {
              var tmp = {
                id: response.id,
                selected: false,
                filename: file.name,
                downloadKey: response.downloadKey
              }
              if (!self.model.idDocAllegatoGar) {
                self.model.idDocAllegatoGar = [];
              }
              self.model.idDocAllegatoGar.push(tmp);
              self.visualProgBarDocGar = false;
            } else if (self.checkGaranti == "priGaranti") {
              var tmp = {
                id: response.id,
                selected: false,
                filename: file.name,
                downloadKey: response.downloadKey
              }
              if (!self.model.idDocAllegatoPrivacyGar) {
                self.model.idDocAllegatoPrivacyGar = [];
              }
              self.model.idDocAllegatoPrivacyGar.push(tmp);
              self.visualProgBarDocPriGar = false;
            } else {
              self.model.idDocAllegato = response.id;
              self.model.idDocAllegatoKey = response.downloadKey
              self.visualProgBarDoc = false;
            }
          } else {
            self.visualProgBarDoc = false;
            self.visualProgBarDocGar = false;
            self.visualProgBarDocPriGar = false;
            $rootScope.$broadcast("addAlert", {
              text: "ERROR_UPLOAD"
            })
          }
          jQuery("#uploadInput_document").val("");
          jQuery("#uploadInput_document_gar").val("");
          jQuery("#uploadInput_document_pri_gar").val("");

        })
        .catch(function (error) {
          self.visualProgBarDoc = false;
          self.visualProgBarDocGar = false;
          self.visualProgBarDocPriGar = false;
          jQuery("#uploadInput_document").val("");
          jQuery("#uploadInput_document_gar").val("");
          jQuery("#uploadInput_document_pri_gar").val("");
        });
    });
  };

  self.uploader.onAfterAddingFile = function (fileItem) {
    console.log("fileItem", fileItem);
    self.disabledForUploadingInProgress = true;
    self.progresso = 0;
    if (fileItem.file.size > 26214400) {
      $rootScope.$broadcast("addAlert", {
        text: "MAXIMUM_FILE_SIZE_EXCEEDED",
      });
      fileItem.remove();
      jQuery("#uploadInput_document").val("");
      jQuery("#uploadInput_document_gar").val("");
      jQuery("#uploadInput_document_pri_gar").val("");
    }
    var fileName = fileItem.file.name;
    if (
      fileName.toLowerCase().indexOf(".png") > -1 ||
      fileName.toLowerCase().indexOf(".jpg") > -1 ||
      fileName.toLowerCase().indexOf(".jpeg") > -1 ||
      fileName.toLowerCase().indexOf(".tiff") > -1 ||
      fileName.toLowerCase().indexOf(".pdf") > -1 ||
      fileName.toLowerCase().indexOf(".zip") > -1 ||
      fileName.toLowerCase().indexOf(".p7m") > -1
    ) {
      self.uploader.queue[0].progress = 100;

      if (self.checkGaranti == "garanti") {
        self.visualProgBarDocGar = true;
      } else if (self.checkGaranti == "priGaranti") {
        self.visualProgBarDocPriGar = true;
      } else {
        self.visualProgBarDoc = true;
      }

      $timeout(function () {
        self.progresso = 100;
      }, 500);
    } else {
      fileItem.remove();
      jQuery("#uploadInput_document").val("");
      jQuery("#uploadInput_document_gar").val("");
      jQuery("#uploadInput_document_pri_gar").val("");
      $rootScope.$broadcast("addAlert", {
        text: "FORMAT_NOT_SUPPORTED",
      });
      self.disabledForUploadingInProgress = false;
      self.uploadInProgess({
        uploadInProgess: false,
      });
    }
  };

  self.uploader.onAfterAddingAll = function (addedFileItems) {
    console.info("onAfterAddingAll", addedFileItems);
    self.finalUpload(self.uploadData);
  };

  self.uploader.onBeforeUploadItem = function (item) {
    item.file.name = window.encodeURIComponent(item.file.name);
    item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
    self.disabledForUploadingInProgress = true;
    self.uploadInProgess({
      uploadInProgess: true,
    });
  };

  self.uploader.onProgressItem = function (fileItem, progress) {
    self.uploadCompleted = false;
  };

  self.uploader.onProgressAll = function (progress) { };

  self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
    self.loadingStatus.uploading = false;
  };

  self.uploader.onErrorItem = function (fileItem, response, status, headers) {
    console.info("onErrorItem", fileItem, response, status, headers);
    self.loadingStatus.uploading = false;
    jQuery("#uploadInput_document").val("");
    jQuery("#uploadInput_document_gar").val("");
    jQuery("#uploadInput_document_pri_gar").val("");

    $rootScope.$broadcast("addAlert", {
      text: "ERROR_UPLOADING_FILE",
    });

    self.disabledForUploadingInProgress = false;
    self.uploadInProgess({
      uploadInProgess: false,
    });
    $timeout(function () {
      if (self.checkGaranti == "garanti") {
        self.visualProgBarDocGar = false;
      } else if (self.checkGaranti == "priGaranti") {
        self.visualProgBarDocPriGar = false;
      } else {
        self.visualProgBarDoc = false;
      }
    }, 1);

    fileItem.remove();
    jQuery("#uploadInput_document").val("");
    jQuery("#uploadInput_document_gar").val("");
    jQuery("#uploadInput_document_pri_gar").val("");
  };

  self.uploader.onCancelItem = function (fileItem, response, status, headers) {
    console.log(status);
  };

  self.uploader.onCompleteItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    console.info("onCompleteItem", fileItem, response, status, headers);
    if (
      response &&
      response.uploadFileServicePojo &&
      response.uploadFileServicePojo.success
    ) {
      self.uploadOk = true;
      console.log(fileItem);

      var document = {
        fileStatus: null,
        isSelected: false,
        nameFile: response.uploadFileServicePojo.fileName,
        uuid: "",
        errorMessage: "",
        documentClass: "",
      };

      self.listOfFilesUpload = response.metadataUniUpload.uploadedfile.sort(
        function (a, b) {
          if (a.codiceDocNSIL > b.codiceDocNSIL) {
            return 1;
          } else {
            return -1;
          }
        }
      );
      self.checkStatusOfFile();
      checkIfFileRequestIsUploaded();
    }
    self.uploader.queue = [];

    $timeout(function () {
      if (self.checkGaranti == "garanti") {
        self.visualProgBarDocGar = false;
      } else if (self.checkGaranti == "priGaranti") {
        self.visualProgBarDocPriGar = false;
      } else {
        self.visualProgBarDoc = false;
      }

      self.disabledForUploadingInProgress = false;
      self.uploadInProgess({
        uploadInProgess: false,
      });
    }, 1);
    jQuery("#uploadInput_document").val("");
    jQuery("#uploadInput_document_gar").val("");
    jQuery("#uploadInput_document_pri_gar").val("");
  };

  self.uploader.onCompleteAll = function () {
    console.info("onCompleteAll");
    self.uploadCompleted = true;
  };

  self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
    self.uploading = false;
  };

  self.deleteDocument = function (value) {
    self.progresso = 100;
    var deletedId = [];
    if (value == "garanti") {
      self.visualProgBarDocGar = true;
      deletedId = self.model.idDocAllegatoGar
        .filter(function (element) {
          return element.selected == true;
        }).map(function (el) {
          return el.downloadKey
        });
    } else if (value == "priGaranti") {
      self.visualProgBarDocPriGar = true;
      deletedId = self.model.idDocAllegatoPrivacyGar
        .filter(function (element) {
          return element.selected == true;
        }).map(function (el) {
          return el.downloadKey
        })
    } else {
      self.visualProgBarDoc = true;
      deletedId.push(self.model.idDocAllegatoKey);
    }

    $timeout(function () {
      self.progresso = 0;
    }, 200);

    deletedId.forEach(function (iesimoId) {
      $simulationService
        .deleteChecklistFileDigital(iesimoId)
        .then(function (response) {
          console.log(response);
          if (response.success) {
            $timeout(function () {
              if (value == "garanti") {
                self.visualProgBarDocGar = false;
                self.model.idDocAllegatoGar = self.model.idDocAllegatoGar
                  .filter(function (element) {
                    return element.selected != true;
                  });
              } else if (value == "priGaranti") {
                self.visualProgBarDocPriGar = false;
                self.model.idDocAllegatoPrivacyGar = self.model.idDocAllegatoPrivacyGar
                  .filter(function (element) {
                    return element.selected != true;
                  });
              } else {
                self.visualProgBarDoc = false;
                self.model.idDocAllegatoKey = null;
              }
            }, 1);
          } else {
            if (value == "garanti") {
              self.visualProgBarDocGar = false;
            } else if (self.checkGaranti == "priGaranti") {
              self.visualProgBarDocPriGar = false;
            } else {
              self.visualProgBarDoc = false;
            }
          }
        })
        .catch(function (error) {
          $rootScope.$broadcast("addAlert", {
            text: "ERROR_TEC",
          });
          self.visualProgBarDoc = false;
          self.visualProgBarDocGar = false;
          self.visualProgBarDocPriGar = false;
        });
    })
  };

  self.enabledButtonModal = function () {
    var form =
      $scope.accettazioneFirmatari && $scope.accettazioneFirmatari.$valid;
    if (!!self.model.relativeUrlGar) {
      return (
        checkIfDateIsOk() &&
        self.model.confirmed &&
        form &&
        !!self.model.identificatore &&
        !!self.model.identificatore.ndg &&
        ((!!self.model.idDocAllegatoKey &&
          !!(self.model.idDocAllegatoGar && self.model.idDocAllegatoGar.length) &&
          (self.checkFileDownload && self.checkFileDownloadGar) || self.model.downloadedOk) || self.model.hideAllegati)
      );
    } else {
      return (
        checkIfDateIsOk() &&
        self.model.confirmed &&
        form &&
        !!self.model.identificatore &&
        !!self.model.identificatore.ndg &&
        ((!!self.model.idDocAllegatoKey &&
          (self.checkFileDownload) || self.model.downloadedOk) || self.model.hideAllegati)
      );
    }
  };

  self.modifyButton = function (value) {
    self.model.confirmed = value;
  };

  self.downloadFile = function (downloadKey) {
    var input = {
      downloadKey: downloadKey
    }
    var url = "/uni/downloadDocDigital/service-infos/"
    $download.getGenericDownload(url, input)
      .then(function (response) {
        console.log(response)
      })
  }

  self.digitalButton = function () {
    $modalService.closeModal("dichIdentFirm-modal");
    $("#footerInstant").css("z-index", "2");
    $(".financial-leasing__footer").css("z-index", "2");
    $transactionFactory.set(self.model);
    self.sendFromDigital();
  };

  self.backModal = function () {
    $modalService.closeModal("dichIdentFirm-modal");
    $("#footerInstant").css("z-index", "2");
    $(".financial-leasing__footer").css("z-index", "2");
    self.close();
  };

  var checkIfDateIsOk = function () {
    if (self.model.showDataAvo) {
      var diffData = moment
        .duration(
          moment(self.model.dataFirmaModulo, "DD/MM/YYYY").diff(
            moment(self.model.dataRiconoscimento, "DD/MM/YYYY")
          )
        )
        .asDays();

      if (diffData < 0) {
        self.model.dataFirmaModulo = null;
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  };

  self.check = function (el) {
    el.selected = !el.selected
  }

  self.enableTrashAttachedGar = function () {
    return !(self.model.idDocAllegatoGar &&
      self.model.idDocAllegatoGar
        .some(function (element) {
          return element.selected == true
        })
    )
  }

  self.enableTrashAttachedPrivacyGar = function () {
    return !(self.model.idDocAllegatoPrivacyGar &&
      self.model.idDocAllegatoPrivacyGar
        .some(function (element) {
          return element.selected == true
        })
    )
  }

  self.selectedClientManager = function (clientManager) {
    var index = self.model.clientManagerList && self.model.clientManagerList.findIndex(function (element) {
      return element.ndg == clientManager.ndg;
    })

    self.model.clientManagerList[index].selected = true

  }
}